// « Vous aimerez aussi » (sections/product-recommendations-respire.liquid).
// Flèches : visibles seulement s'il y a des produits hors champ ; chaque
// clic fait défiler d'une rangée complète (aucune carte coupée, grâce au
// scroll-snap des cartes). Désactivées en début et en fin de liste.
(function () {
  function setup(root) {
    if (root.dataset.ocRecReady) return;
    root.dataset.ocRecReady = 'true';

    var track = root.querySelector('[data-oc-rec-track]');
    var nav = root.querySelector('[data-oc-rec-nav]');
    var prev = root.querySelector('[data-oc-rec-prev]');
    var next = root.querySelector('[data-oc-rec-next]');
    if (!track || !nav || !prev || !next) return;

    function pageWidth() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return track.clientWidth + gap;
    }

    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 2;
      nav.hidden = !overflow;
      root.classList.toggle('oc-rec--static', !overflow);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageWidth() });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: pageWidth() });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-oc-rec]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
